function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M12 2.056c3.87 0 7 3.183 7 7.102 0 .745-.097 1.518-.284 2.316-.47 2.008-1.485 4.113-2.88 6.24-.677 1.033-1.4 2.005-2.125 2.889-.254.31-.49.587-.703.829l-.074.083-.204.225c-.395.422-1.065.422-1.46 0l-.14-.153-.302-.343-.172-.2-.367-.441c-.724-.884-1.448-1.856-2.125-2.889-1.395-2.127-2.41-4.232-2.88-6.24C5.097 10.676 5 9.904 5 9.158c0-3.919 3.13-7.102 7-7.102zm0 2c-2.758 0-5 2.28-5 5.102 0 .584.078 1.206.231 1.86.41 1.745 1.328 3.652 2.605 5.6.636.97 1.318 1.885 2 2.717l.164.198.164-.198c.546-.665 1.091-1.385 1.613-2.142l.387-.575c1.277-1.948 2.196-3.855 2.605-5.6.153-.654.231-1.276.231-1.86 0-2.822-2.242-5.102-5-5.102zm0 2c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 2c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.43ded252.svg";
export { ForwardRef as ReactComponent };